import React, { useState, useEffect } from 'react';
import Select from "react-select";
import { get_address, edit_addresses } from '../../api/Product';
import { useNavigate } from 'react-router-dom';
import Country_State_Data from '../country_state_data/Country_State_Data';
import { toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import Header from "../../comps/Header";
import Footer from "../../comps/Footer";

const Edit_Shipping_Address = () => {
    const navigate = useNavigate();
    const get_user_data = localStorage.getItem("user");
    const parsedUserData = JSON.parse(get_user_data);
    console.log("User Email:", parsedUserData?.name);

    const [formData, setFormData] = useState({
        id: null,
        type: "shipping",
        fullName: '',
        address: '',
        city: '',
        state: '',
        zip: '',
        country: '',
        phone: '',
        email: parsedUserData?.email || '',
    });
    const [phoneError, setPhoneError] = useState("");

    const [stateOptions, setStateOptions] = useState([]);
    const token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" };

    // Convert country options for react-select
    const countryOptions = Object.entries(Country_State_Data).map(([code, details]) => ({
        value: code,
        label: details.name,
    }));

    // Fetch Address List when component mounts
    useEffect(() => {
        const fetchAddressList = async () => {
            try {
                const response = await get_address(headers);
                console.log("Fetched Address List:", response?.data);
                const shippingAddresses = response?.data?.filter(item => item?.type == "shipping");
                const lastShippingAddress = shippingAddresses?.length > 0 ? shippingAddresses.pop() : null;

                if (lastShippingAddress) {
                    setFormData({
                        id: lastShippingAddress.id,
                        fullName: lastShippingAddress.fullName || '',
                        address: lastShippingAddress.address || '',
                        city: lastShippingAddress.city || '',
                        zip: lastShippingAddress.zip || '',
                        phone: lastShippingAddress.phone || '',
                        email: lastShippingAddress.email || parsedUserData?.email || '',
                        country: countryOptions.find(c => c.value === lastShippingAddress.country) || null,
                        state: stateOptions.find(s => s.value === lastShippingAddress.state) || null,
                    });

                    updateStateOptions(lastShippingAddress.country);
                }
            } catch (error) {
                console.error("Error fetching addresses:", error);
            }
        };

        fetchAddressList();
    }, []);


    // Update state options based on selected country
    const updateStateOptions = (countryCode) => {
        const states = Country_State_Data[countryCode]?.states || [];
        setStateOptions(states.map(state => ({ value: state, label: state })));
    };

    // Phone number change handler
    const handlePhoneChange = (phone) => {
        setFormData({ ...formData, phone });

        // Validate phone immediately
        if (!phone || !isValidPhoneNumber(phone)) {
            setPhoneError("Please enter a valid phone number.");
        } else {
            setPhoneError("");
        }
    };

    // Handle input change
    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    // Handle Country Selection
    const handleCountryChange = (selectedOption) => {
        setFormData({ ...formData, country: selectedOption, state: '' });
        updateStateOptions(selectedOption.value);
    };

    // Handle State Selection
    const handleStateChange = (selectedOption) => {
        setFormData({ ...formData, state: selectedOption });
    };

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();

        const formDataToSend = new FormData();

        Object.entries(formData).forEach(([key, value]) => {
            if (typeof value == "object" && value !== null && "value" in value) {
                formDataToSend.append(key, value.value);  // Extract value if it's an object
            } else {
                formDataToSend.append(key, value);
            }
        });

        if (!formData.id) {
            console.error("Address ID is missing");
            return;
        }

        try {
            const response = await edit_addresses(formData.id, formDataToSend, headers);
            console.log("Edit API Response:", response);
            toast.error("Billing address updated successfully!");
            navigate("/my-account")
        } catch (error) {
            console.error("Error updating address:", error);
        }
    };


    return (
        <>
            {/*  */}
            <Header />
            <div className="min-h-screen bg-gray-50 flex items-center justify-center p-6">
                <div className="bg-white shadow-md rounded-lg w-full max-w-lg">
                    {/* <-------- ToastContainer ------------> */}
                    <ToastContainer style={{ marginTop: "120px" }} />
                    <div className="px-6 py-4 border-b">
                        <h2 className="text-2xl font-bold text-gray-800">Edit Billing Address</h2>
                    </div>
                    <form className="px-6 py-4" onSubmit={handleSubmit}>

                        {/* Email */}
                        <div className="mb-4">
                            <label htmlFor="email" className="block text-gray-700 mb-2">Email address</label>
                            <input type="text" id="email" name="email" value={formData.email} onChange={handleChange} required className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring focus:border-blue-300" />
                        </div>

                        {/* Full Name */}
                        <div className="mb-4">
                            <label htmlFor="fullName" className="block text-gray-700 mb-2">Full Name</label>
                            <input type="text" id="fullName" name="fullName" value={parsedUserData?.name} onChange={handleChange} required className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring focus:border-blue-300" />
                        </div>

                        {/* Address */}
                        <div className="mb-4">
                            <label htmlFor="address" className="block text-gray-700 mb-2">Address</label>
                            <input type="text" id="address" name="address" value={formData.address} onChange={handleChange} required className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring focus:border-blue-300" />
                        </div>

                        {/* Country Dropdown */}
                        <div className="mb-4">
                            <label className="block text-gray-700 mb-2">Country *</label>
                            <Select options={countryOptions} value={formData.country} onChange={handleCountryChange} placeholder="Select a country..." />
                        </div>

                        {/* State Dropdown */}
                        {stateOptions.length > 0 && (
                            <div className="mb-4">
                                <label className="block text-gray-700 mb-2">State *</label>
                                <Select options={stateOptions} value={formData.state} onChange={handleStateChange} placeholder="Select a state..." />
                            </div>
                        )}

                        {/* ZIP Code and City */}
                        <div className="mb-4 grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div>
                                <label htmlFor="zip" className="block text-gray-700 mb-2">ZIP Code</label>
                                <input type="text" id="zip" name="zip" value={formData.zip} onChange={handleChange} required className="w-full px-3 py-2 border rounded-md" />
                            </div>
                            <div>
                                <label htmlFor="city" className="block text-gray-700 mb-2">City</label>
                                <input type="text" id="city" name="city" value={formData.city} onChange={handleChange} required className="w-full px-3 py-2 border rounded-md" />
                            </div>
                        </div>

                        {/* Phone */}
                        {/* <div className="mb-4">
                        <label htmlFor="phone" className="block text-gray-700 mb-2">Phone Number</label>
                        <input type="number" id="phone" name="phone" value={formData.phone}
                            onChange={handleChange} required className="w-full px-3 py-2 border rounded-md" />
                    </div> */}

                        <div>
                            <label className="block text-sm font-medium text-gray-400 mb-1">Phone:</label>
                            <PhoneInput defaultCountry="US" placeholder="Enter phone number" value={formData.phone} onChange={handlePhoneChange} className="w-full rounded-lg h-10 px-4 text-sm placeholder:text-gray-500 border border-gray-200 focus:border-blue-200 focus:ring-1 focus:ring-blue-100" />
                            {phoneError && (
                                <p className="text-red-500 text-xs mt-1">{phoneError}</p>
                            )}

                        </div>

                        {/* Save Button */}
                        <div className="flex justify-center mt-4">
                            <button type="submit" className="bg-blue-600 text-white  px-6 py-2 rounded-md hover:bg-blue-700">Save Address</button>
                        </div>
                    </form>
                </div>
            </div>
            {/*  */}
            <Footer />
        </>
    );
};

export default Edit_Shipping_Address;
